export default __webpack_public_path__ + "static/media/top_performer (1).405b382d.png";